/* tslint:disable quotemark */
/* tslint:disable max-line-length */
export const el = {
    "Error": {
      "Continue": "Συνέχεια",
      "LoginAsDiffrentUser": "Είσοδος ως διαφορετικός χρήστης",
      "Logout": "Αποσύνδεση"
    },
    "E0": {
        "title": "Αποτυχία σύνδεσης",
        "message": "Η σύνδεση με το διακομιστή απέτυχε. Προσπαθήστε ξανά",
        "1": {
            "title": "Αποτυχία παραλαβής στοιχείων σύνδεσης",
            "message": "Η σύνδεση με το διακομιστή εξουσιοδότησης απέτυχε ή τα στοιχεία διασύνδεσης δεν είναι έγκυρα. Προσπαθήστε ξανά.",
        }
    },
    "E400": {
        "title": "Εσφαλμένη αίτηση",
        "message": "Το αίτημα δεν μπορεί να ικανοποιηθεί λόγω κακής σύνταξης.",
        "1": {
          "title": "Η συνεδρία σας έληξε",
          "message": "Παρακαλούμε συνδεθείτε ξανά."
        }
    },
    "E401": {
        "title": "Μη εξουσιοδοτημένη πρόσβαση",
        "message": "Η πρόσβαση δεν επιτρέπεται λόγω μη έγκυρων διαπιστευτηρίων.",
        "1": {
            "title": "Απαιτείται ενεργή σύνδεση",
            "message": "Η πρόσβαση δεν επιτρέπεται λόγω μη έγκυρων διαπιστευτηρίων ή η διάρκεια της σύνδεσης σας έχει λήξει."
        }
    },
    "E403": {
        "title": "Απαγόρευση",
        "message": "Ο διακομιστής κατανόησε το αίτημα, αλλά αρνείται να το εκπληρώσει.",
        "1": {
            "title": "Δεν επιτρέπεται η πρόσβαση",
            "message": "Ο διακομιστής κατανόησε το αίτημα, αλλά δεν έχετε την κατάλληλη άδεια πρόσβασης σε αυτόν τον πόρο."
        },
      "2": {
          "title": "Δεν επιτρέπεται η πρόσβαση",
          "message": "Ο διακομιστής κατανόησε το αίτημα, αλλά δεν είστε ενεργός χρήστης και δεν δεν έχετε άδεια πρόσβασης σε αυτόν τον πόρο"
      },
      "3": {
        "title": "Δεν επιτρέπεται η πρόσβαση",
        "message": "Ο διακομιστής κατανόησε το αίτημα, αλλά δεν υπάρχουν ενεργά τμήματα σε αυτόν τον πόρο " +
          "ή ο χρήστης δεν έχει δικαιώματα σε κάποιο από τα τμήματα του ιδρύματος."
      }
    },
    "E404": {
        "title": "Δεν βρέθηκε",
        "message": "Ο πόρος δεν ήταν δυνατό να βρεθεί αλλά μπορεί να είναι και πάλι διαθέσιμος στο μέλλον.",
        "1": {
            "title": "Το προφίλ σας δε βρέθηκε",
            "message": "Προσπαθήστε ξανά. Εάν το πρόβλημα παραμείνει επικοινωνήστε με τους διαχειριστές του συστήματος σας."
        },
        "2": {
            "title": "Το προφίλ του χρήστη δεν βρέθηκε",
            "message": "Προσπαθήστε ξανά. Εάν το πρόβλημα παραμείνει επικοινωνήστε με τους διαχειριστές του συστήματος σας."
        },
        "3": {
            "title": "Η αίτηση δεν βρέθηκε",
            "message": "Προσπαθήστε ξανά. Εάν το πρόβλημα παραμείνει επικοινωνήστε με τους διαχειριστές του συστήματος σας."
        },
        "4": {
            "title": "Το συμβόλαιο δεν βρέθηκε",
            "message": "Προσπαθήστε ξανά. Εάν το πρόβλημα παραμείνει επικοινωνήστε με τους διαχειριστές του συστήματος σας."
        }
    },
    "E405": {
        "title": "Δεν επιτρέπεται η εφαρμογή της μεθόδου",
        "message": "Ζητήθηκε ένας πόρος χρησιμοποιώντας μια μέθοδο αίτησης που δεν υποστηρίζεται από αυτόν τον πόρο."
    },
    "E406": {
        "title": "Δεν είναι αποδεκτό",
        "message": "Ο πόρος είναι ικανός να παράγει περιεχόμενο μη αποδεκτό σύμφωνα με τις κεφαλίδες Accept που αποστέλλονται στην αίτηση."
    },
    "E407": {
        "title": "Απαιτείται έλεγχος ταυτότητας διακομιστή μεσολάβησης",
        "message": "Ο πελάτης πρέπει πρώτα να επικυρώσει τον εαυτό του με το διακομιστή μεσολάβησης."
    },
    "E408": {
        "title": "Χρονικό όριο αίτησης",
        "message": "The server timed out waiting for the request.",
      "1": {
        "title": "Αποτυχία σύνδεσης",
        "message": "Η σύνδεση με το διακομιστή απέτυχε. Προσπαθήστε ξανά"
      }
    },
    "E409": {
        "title": "Σύγκρουση",
        "message": "Το αίτημα δεν ήταν δυνατό να ολοκληρωθεί λόγω διένεξης με την τρέχουσα κατάσταση του πόρου."
    },
    "E410": {
        "title": "Gone",
        "message": "The resource requested is no longer available and will not be available again."
    },
    "E411": {
        "title": "Length Required",
        "message": "The request did not specify the length of its content, which is required by the requested resource."
    },
    "E412": {
        "title": "Precondition Failed",
        "message": "The server does not meet one of the preconditions that the requester put on the request."
    },
    "E413": {
        "title": "Υπέρβαση μεγέθους αιτήματος",
        "message": "Το μέγεθος του αιτήματος είναι μεγαλύτερο από αυτό που επιτρέπει ή μπορεί να επεξεργαστεί ο διακομιστής."
    },
    "E414": {
        "title": "Υπέρβαση μήκους διεύθυνσης",
        "message": "Η διέυθυνση του αιτήματος ήταν πολύ μεγάλη για να την επεξεργαστεί ο διακομιστής."
    },
    "E415": {
        "title": "Υπέρβαση μεγέθους αιτήματος",
        "message": "Το μέγεθος του αιτήματος είναι μεγαλύτερο από αυτό που επιτρέπει ή μπορεί να επεξεργαστεί ο διακομιστής."
    },
    "E416": {
        "title": "Requested Range Not Satisfiable",
        "message": "The client has asked for a portion of the file, but the server cannot supply that portion."
    },
    "E417": {
      "title": "Expectation Failed",
      "message": "The server cannot meet the requirements of the Expect request-header field."
    },
    "E422": {
      "title": "Μη έγκυρο αρχείο",
      "message": "Ο διακομιστής δεν μπορεί να επεξεργαστεί τα δεδομένα του αρχείου."
    },
    "E429": {
        "title": "Μεγάλος αριθμός αιτήσεων",
        "message": "Έχουν πραγματοποιηθεί πάρα πολλές αιτήσεις προς τον διακομιστή. Δοκιμάστε ξανά αργότερα."
    },
    "E496": {
        "title": "Έλλειψη πιστοποιητικού",
        "message": "Ένα έγκυρο πιστοποιητικό είναι απαραίτητο για την ολοκλήρωση του αιτήματος."
    },
    "E498": {
        "title": "Λήξη κλειδιού πιστοποίησης",
        "message": "Το κλειδί πιστοποίησης έχει λήξει ή δεν είναι έγκυρο."
    },
    "E499": {
        "title": "Απαιτείται κλειδί πιστοποίησης",
        "message": "Ένα έγκυρο κλειδί πιστοποίσης είναι απαραίτητο για να ολοκληρωθεί η ενέργεια.",
        "1": {
            "title": "Μη έγκυρος πελάτης πιστοποίησης",
            "message": "Ο επιλεγμένος πελάτης πιστοποίησης δεν επιτρέπεται να πραγματοποιήσει την διαδικασία πιστοποιήσης με τις ορισμένες παραμέτρους."
        },
        "2": {
            "title": "Εσωτερικό σφάλμα πιστοποίησης",
            "message": "Το τελευταίο στάδιο της διαδικασίας πιστοποίησης δεν μπορεί να ολοκληρωθεί λόγω εσωτερικού σφάλματος."
        }
    },
    "E500": {
        "title": "Εσωτερικό σφάλμα διακομιστή",
        "message": "Ο διακομιστής αντιμετώπισε ένα εσωτερικό σφάλμα και δεν μπόρεσε να ολοκληρώσει το αίτημά σας."
    },
    "E501": {
        "title": "Αδυναμία ολοκλήρωσης αιτήματος",
        "message": "Ο διακομιστής είτε δεν αναγνωρίζει τη μέθοδο αιτήματος, είτε δεν έχει τη δυνατότητα να εκπληρώσει το αίτημα."
    },
    "E502": {
        "title": "Μη έγκυρη απάντηση",
        "message": "Ο διακομιστής λειτούργησε ως πύλη ή διακομιστής μεσολάβησης και έλαβε μια μη έγκυρη απάντηση."
    },
    "E503": {
        "title": "Μη διαθέσιμη υπηρεσία",
        "message": "Ο διακομιστής δεν είναι διαθέσιμος αυτήν τη στιγμή (επειδή είναι υπερφορτωμένος ή εκτός λειτουργίας για συντήρηση)."
    }
};
/* tslint:enable max-line-length */
/* tslint:enable quotemark */

